import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './styles/index.css';
import HomePage from './pages/HomePage';
import DonatePage from './pages/DonatePage';
import ThankYouPage from './pages/ThankYouPage';
import SignInPage from './pages/SignInPage';
import VoucherPage from './pages/VoucherPage';
import VoucherProgramPage from './pages/VoucherProgramPage';
import ContactPage from './pages/ContactPage';
import PawsitiveDeckPage from './pages/PawsitiveDeckPage';
import OAuthInteractionPage from './pages/OAuthInteractionPage';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import PageViews from './components/PageViews';
import { ThemeProvider } from './theme/ThemeProvider';

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col">
          <Navigation />
          <main className="flex-grow">
            {/* Indexable routes are listed in public/sitemap.xml; the rest are disallowed in public/robots.txt. */}
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/donate" element={<DonatePage />} />
              <Route path="/voucher-program" element={<VoucherProgramPage />} />
              <Route path="/contact" element={<ContactPage />} />
              {/* A category with one product so far; the bare path lands on it. */}
              <Route path="/products" element={<Navigate to="/products/pawsitive-deck" replace />} />
              <Route path="/products/pawsitive-deck" element={<PawsitiveDeckPage />} />
              <Route path="/thank-you" element={<ThankYouPage />} />
              <Route path="/sign-in" element={<SignInPage mode="sign-in" />} />
              <Route path="/signup" element={<SignInPage mode="sign-up" />} />
              {/* The sign-up tab was briefly served here; this keeps links to it working. */}
              <Route path="/sign-up" element={<Navigate to="/signup" replace />} />
              {/* Donors used to sign in here; this keeps old links and emails working. */}
              <Route path="/donor-portal" element={<Navigate to="/sign-in" replace />} />
              {/* Every voucher's QR code encodes /voucher?code=<code>. */}
              <Route path="/voucher" element={<VoucherPage />} />
              {/* Where an app connecting to the API (Claude, ChatGPT, Codex) sends the person to sign in.
                  The path must match the API's own /oauth/interaction routes — see lib/oauthInteraction. */}
              <Route path="/oauth/interaction/:uid" element={<OAuthInteractionPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
        {/* After the routes: effects run in tree order, so the page's usePageMeta has set the title. */}
        <PageViews />
      </Router>
    </ThemeProvider>
  );
};

export default App;
